import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconStatusChange } from '@tabler/icons-react';
import { BetaSchemaForm, ProFormColumnsType } from '@ant-design/pro-components';
import { CrudMode } from '@ohpen/enso-ui';

import { TabProps } from '../interfaces';
import { FirmGetById } from '@pmp/api';
import { CrudFormCard } from './CrudFormCard';

export const Status: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  const { t } = useTranslation();
  const readonly = mode === CrudMode.VIEW;

  const columns: ProFormColumnsType<FirmGetById, 'text'>[] = useMemo(
    () => [
      {
        title: t('lender.firms.labels.compliance'),
        dataIndex: ['status', 'complianceStatus'],
        valueType: 'radio',
        readonly,
        formItemProps: {
          rules: [{ required: true }],
        },
        fieldProps: {
          options: [
            { label: t('lender.firms.labels.pending'), value: 'UNDECIDED' },
            { label: t('lender.firms.labels.notRequired'), value: 'NOT_REQUIRED' },
            { label: t('lender.firms.labels.failed'), value: 'FAILED' },
            { label: t('lender.firms.labels.passed'), value: 'PASSED' },
          ],
        },
        colProps: { span: 24 },
      },
      {
        valueType: 'group',
        gutter: [24, 0],
        columns: [
          {
            title: t('lender.firms.labels.complianceReReviewRequired'),
            dataIndex: ['status', 'reviewRequired'],
            valueType: 'radio',
            readonly,
            fieldProps: {
              options: [
                { label: t('global.labels.yes'), value: true },
                { label: t('global.labels.no'), value: false },
              ],
            },
            formItemProps: {
              rules: [{ required: true }],
            },
            colProps: { span: 12 },
          },
          {
            title: t('lender.firms.labels.watchlist'),
            dataIndex: ['status', 'onTheWatchlist'],
            valueType: 'radio',
            readonly,
            fieldProps: {
              options: [
                { label: t('global.labels.yes'), value: true },
                { label: t('global.labels.no'), value: false },
              ],
            },
            formItemProps: {
              rules: [{ required: true }],
            },
            colProps: { span: 12 },
          },
        ],
      },
      {
        title: t('lender.firms.labels.complianceRecord'),
        valueType: 'group',
        colProps: { span: 24 },
        gutter: [24, 0],
        columns: [
          {
            title: t('lender.firms.labels.addedToPanel'),
            dataIndex: ['status', 'addedToPanel'],
            valueType: 'date',
            readonly: true,
            colProps: { span: 6 },
          },
          {
            title: t('global.labels.addedBy'),
            dataIndex: ['status', 'addedBy'],
            valueType: 'text',
            readonly: true,
            colProps: { span: 6 },
          },
          {
            title: t('global.labels.lastUpdate'),
            dataIndex: ['status', 'lastUpdate'],
            valueType: 'date',
            readonly: true,
            colProps: { span: 6 },
          },
          {
            title: t('global.labels.updatedBy'),
            dataIndex: ['status', 'updatedBy'],
            valueType: 'text',
            readonly: true,
            colProps: { span: 6 },
          },
        ],
      },
    ],
    [readonly, t],
  );

  return (
    <CrudFormCard icon={<IconStatusChange />} title={t('lender.firms.labels.status')}>
      <BetaSchemaForm<FirmGetById> form={form} layoutType="Embed" columns={columns} submitter={false} />
    </CrudFormCard>
  );
};
